const getBase = () => process.env.REACT_APP_API_URL || '';

export const fetchProducts = async () => {
  const url = `${getBase()}/api/products`;
  try {
    const res = await fetch(url);
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || 'Falha ao carregar produtos');
    }
    return res.json();
  } catch (e) {
    const isNetworkError =
      e.name === 'TypeError' ||
      (e.message && (e.message.includes('fetch') || e.message === 'Failed to fetch'));
    if (isNetworkError) {
      throw new Error(
        'Não foi possível conectar ao servidor. Verifique se o backend está rodando (npm start na pasta backend).'
      );
    }
    throw e;
  }
};

export const fetchProduct = async (id) => {
  const url = `${getBase()}/api/products/${encodeURIComponent(id)}`;
  try {
    const res = await fetch(url);
    if (!res.ok) {
      if (res.status === 404) return null;
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || 'Falha ao carregar produto');
    }
    return res.json();
  } catch (e) {
    const isNetworkError =
      e.name === 'TypeError' ||
      (e.message && (e.message.includes('fetch') || e.message === 'Failed to fetch'));
    if (isNetworkError) {
      throw new Error(
        'Não foi possível conectar ao servidor. Verifique se o backend está rodando (npm start na pasta backend).'
      );
    }
    throw e;
  }
};
